'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { createSelector } from 'reselect';
import { omit } from 'underscore';
import { createLayoutTreeFromNormalizedData } from 'DesignData/lib/normalization/layouts';
import { getLayout } from 'DesignData/selectors/layouts';
import { getLayoutData } from 'DesignData/selectors/layoutData';
import { getGates } from 'DesignData/selectors/auth';
import { LAYOUT_WIDGET_PREFER_PATH_KEY } from 'DesignData/enums/Gates';
import { getCustomWidgetsData } from 'DesignData/selectors/customWidgets';
import { compose } from 'redux';

function makeFixes({
  customWidgets,
  gates
}) {
  function usePathAsKey(widget) {
    if (widget.type !== 'custom_widget' && widget.type !== 'module') {
      return widget;
    }

    if (widget.params.custom_widget_id) {
      if (!widget.params.path) {
        const customWidget = customWidgets[widget.params.custom_widget_id];

        if (!customWidget) {
          return widget;
        }

        widget.params.path = customWidget.path;
      }
    }

    return widget;
  }

  function preferPathAsKey(widget) {
    if (widget.type !== 'custom_widget' && widget.type !== 'module') {
      return widget;
    }

    if (!widget.params.path) {
      return widget;
    }

    if (widget.params.custom_widget_id) {
      delete widget.params.custom_widget_id;
    }

    if (widget.params.module_id) {
      delete widget.params.module_id;
    }

    if (widget.moduleData && widget.params.path) {
      if (widget.moduleData.body) {
        if (widget.moduleData.body.custom_widget_id) {
          delete widget.moduleData.body.custom_widget_id;
        }

        if (widget.moduleData.body.module_id) {
          delete widget.moduleData.body.module_id;
        }

        widget.moduleData.body.path = widget.params.path;
      }

      if (widget.moduleData.module_id) {
        delete widget.moduleData.module_id;
      }
    }

    return widget;
  }

  const nodeModifiers = gates[LAYOUT_WIDGET_PREFER_PATH_KEY] ? [usePathAsKey, preferPathAsKey] : [usePathAsKey];
  return compose(...nodeModifiers);
}
/**
 * Required props:
 *  - layoutId || assetId
 */


export const getSerializableLayout = createSelector([getLayout, getLayoutData, getCustomWidgetsData, getGates], (layout, layoutData, customWidgets, gates) => {
  if (!(layout && layoutData)) return null;
  let resultLayout = SeamlessImmutable.asMutable(layout, {
    deep: true
  });

  if (resultLayout.body) {
    resultLayout = omit(resultLayout, ['body']);
  }

  const nodeModifier = makeFixes({
    customWidgets,
    gates
  });
  resultLayout.layoutData = createLayoutTreeFromNormalizedData(layoutData.widgets, layoutData.rows, layoutData.rootWidgetId, {
    nodeModifier
  });
  return resultLayout;
});